/**
 * AUTOGENERATED, DO NOT EDIT!
 *
 * https://gitlab.com/digital-pharma-tools/open-api-codegen
 *
 */
export enum MarginBottomEnum {
    M_MIN_5 = 'M_MIN_5',
    M_MIN_4 = 'M_MIN_4',
    M_MIN_3 = 'M_MIN_3',
    M_MIN_2 = 'M_MIN_2',
    M_MIN_1 = 'M_MIN_1',
    M_0 = 'M_0',
    M_1 = 'M_1',
    M_2 = 'M_2',
    M_3 = 'M_3',
    M_4 = 'M_4',
    M_5 = 'M_5',
    M_6 = 'M_6',
    M_7 = 'M_7',
}